import "core-js/modules/es.array.concat.js";
import { rem, getRem } from './rem';
var fontSizes = {
  '-4': {
    size: 7,
    compact: 9,
    default: 12
  },
  '-3': {
    size: 9,
    compact: 12,
    default: 15
  },
  '-2': {
    size: 11,
    compact: 15,
    default: 18
  },
  '-1': {
    size: 13,
    compact: 18,
    default: 21
  },
  0: {
    size: 15,
    xcompact: 18,
    compact: 21,
    default: 24
  },
  1: {
    size: 18,
    xcompact: 24,
    compact: 27,
    default: 30
  },
  2: {
    size: 22,
    compact: 30,
    default: 33
  },
  3: {
    size: 26,
    compact: 33,
    default: 36
  },
  4: {
    size: 30,
    compact: 36,
    default: 39
  },
  5: {
    size: 37,
    compact: 45,
    default: 48
  },
  6: {
    size: 45,
    compact: 54,
    default: 57
  },
  7: {
    size: 54,
    compact: 57,
    default: 60
  }
};
var interpolate = function interpolate(start, end, factor) {
  return start + (end - start) * factor;
};
var interpolateFont = function interpolateFont(size, variant) {
  var _fonts$floor$variant2, _fonts$ceil$variant;
  var fonts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : fontSizes;
  var floor = Math.floor(size);
  var ceil = Math.ceil(size);
  if (floor === ceil || !fonts[floor] || !fonts[ceil]) {
    var _fonts$floor$variant, _fonts$floor, _fonts$floor2;
    return (_fonts$floor$variant = (_fonts$floor = fonts[floor]) === null || _fonts$floor === void 0 ? void 0 : _fonts$floor[variant]) !== null && _fonts$floor$variant !== void 0 ? _fonts$floor$variant : (_fonts$floor2 = fonts[floor]) === null || _fonts$floor2 === void 0 ? void 0 : _fonts$floor2.default;
  }
  var lower = (_fonts$floor$variant2 = fonts[floor][variant]) !== null && _fonts$floor$variant2 !== void 0 ? _fonts$floor$variant2 : fonts[floor].default;
  var upper = (_fonts$ceil$variant = fonts[ceil][variant]) !== null && _fonts$ceil$variant !== void 0 ? _fonts$ceil$variant : fonts[ceil].default;
  var factor = size - floor;
  return interpolate(lower, upper, factor);
};
export var getFont = function getFont(size) {
  var variant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
  var fonts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : fontSizes;
  var fontSize = interpolateFont(size, 'size', fonts);
  var lineHeight = interpolateFont(size, variant, fonts);
  return "\n    font-size: ".concat(rem(fontSize), ";\n    line-height: ").concat(rem(lineHeight), ";\n  ");
};
export var getFontSize = function getFontSize(size) {
  var variant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
  var fonts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : fontSizes;
  return getRem(interpolateFont(size, 'size', fonts));
};
export var getLineHeight = function getLineHeight(size) {
  var variant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
  var fonts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : fontSizes;
  return getRem(interpolateFont(size, variant, fonts));
};